// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"calendar-event"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 21L21 21V10L3 10L3 21Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M21 10V5L3 5L3 10L21 10Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 10V21H3V10M21 10H3M21 10V5H3V10M7 5V2M17 5V2","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M13.5 13.5H17.5V17.5H13.5V13.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CalendarEventIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'calendar-event',
    ref,
    icon: element,
  },
));

CalendarEventIcon.displayName = 'CalendarEventIcon';

export default CalendarEventIcon;
